
<div>
	<v-container align="center" justify="center" class="pa-5">
		<v-row justify="center" no-gutters>
			<v-col cols="auto">
				<v-icon size="100px" color="primary" @click="uploadFile">backup</v-icon>
			</v-col>
		</v-row>
		<v-row class="justify-center text-center"
			><v-col style="text-transform: none !important"
				><v-btn class="text-none text-wrap" text color="primary">
					<v-file-input
						ref="idFileInput"
						v-model="idfile"
						:class="{ 'body-1': $vuetify.breakpoint.mdAndUp, caption: $vuetify.breakpoint.smAndDown, 'custom-file-uploader': true }"
						accept=".png, .jpg, .jpeg, .gif, .pdf"
						:placeholder="getLabel('uploadIdDocument', 'Upload ID document')"
						show-size
						:truncate-length="15"
						:rules="rules"
						:prepend-icon="''"
						prepend-inner-icon="cloud_upload"
						style="border: none; color: var(--v-primary-base)"
						@change="handleImage" /></v-btn></v-col
		></v-row>
		<v-row class="justify-center text-center">
			<v-col class="error--text">
				<v-card-text v-show="idError">{{ getLabel('uploadIdDocumentError', 'Please upload an ID document') }}</v-card-text>
			</v-col>
		</v-row>
		<v-row v-if="idExists" align="center" justify="center" class="mb-6">
			<v-col cols="auto" class="text--secondary" style="font-size: 15px">ID document already uploaded. Click above to upload a new document.</v-col>
		</v-row>
		<v-row align="center" justify="center">
			<v-col cols="auto" class="text--secondary text-caption">Supported file formats: PDF, JPG, GIF, PNG</v-col>
		</v-row>
		<v-row align="center" justify="center" no-gutters>
			<v-col cols="auto" class="text--secondary text-caption">Maximum upload file size: 2MB</v-col>
		</v-row>
	</v-container>

	<v-container align="center" justify="center">
		<v-row class="justify-center text-center"
			><v-col cols="auto"> <v-img v-show="showPreview" :max-width="483" :max-height="327" :src="idFilePreview"></v-img> </v-col
		></v-row>
	</v-container>
</div>
